import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
		path: '/',
		redirect: '/index'
	},
	{
		path: '/home',
		component: () => import('../views/home.vue'),
		children:[
      {
    		path: '/index',
    		component: () => import('../views/index.vue'),
        meta: {
    			title: '繁星優選クラウドファンディング'
    		}
    	},
      {
    		path: '/login',
    		component: () => import('../views/login.vue'),
        meta: {
    			title: '繁星優選ログイン'
    		}
    	},
      {
    		path: '/register',
    		component: () => import('../views/register.vue'),
        meta: {
    			title: '繁星優選無料会員登録'
    		}
    	},
		{
    		path: '/registerbefore',
    		component: () => import('../views/registerbefore.vue'),
        meta: {
    			title: '会員登録'
    		}
    	},
		{
    		path: '/bindemail',
    		component: () => import('../views/bindemail.vue'),
        	meta: {
    			title: 'メール登録'
    		}
    	},
		
      {
    		path: '/fundlist',
    		component: () => import('../views/fundlist.vue'),
        meta: {
    			title: 'ファンド一覧'
    		}
    	},
      {
    		path: '/flow',
    		component: () => import('../views/flow.vue'),
        meta: {
    			title: 'ご利用までの流れ'
    		}
    	},
      {
    		path: '/contact',
    		component: () => import('../views/contact.vue'),
        meta: {
    			title: 'お問い合わせ'
    		}
    	},
      {
    		path: '/profile',
    		component: () => import('../views/profile.vue'),
        meta: {
    			title: '運営会社'
    		}
    	},
      {
    		path: '/faq',
    		component: () => import('../views/faq.vue'),
        meta: {
    			title: 'FAQ'
    		}
    	},
      {
    		path: '/funddetail',
    		component: () => import('../views/funddetail.vue'),
        meta: {
    			title: '繁星優選クラウドファンディング'
    		}
    	},
      {
    		path: '/userinfo',
    		component: () => import('../views/userinfo.vue'),
        meta: {
    			title: '個人情報'
    		}
    	},
      {
    		path: '/mypage',
    		component: () => import('../views/mypage.vue'),
        meta: {
    			title: 'マイページ'
    		}
    	},
      {
    		path: '/noticelist',
    		component: () => import('../views/noticelist.vue'),
        meta: {
    			title: 'お知らせ'
    		}
    	},
      {
    		path: '/applylist',
    		component: () => import('../views/applylist.vue'),
        meta: {
    			title: '申込履歴'
    		}
    	},
      {
    		path: '/investlist',
    		component: () => import('../views/investlist.vue'),
        meta: {
    			title: 'マイファンド'
    		}
    	},
      {
    		path: '/investpdf',
    		component: () => import('../views/investpdf.vue'),
        meta: {
    			title: '交付書面一覧'
    		}
    	},
      {
    		path: '/incomedetail',
    		component: () => import('../views/incomedetail.vue'),
        meta: {
    			title: '收益明細'
    		}
    	},
      {
    		path: '/accounthistory',
    		component: () => import('../views/accounthistory.vue'),
        meta: {
    			title: '入出金一覧'
    		}
    	},
      {
    		path: '/reissue',
    		component: () => import('../views/reissue.vue'),
        meta: {
    			title: 'パスワード再設定申請'
    		}
    	}
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
